import { render } from "./DigitalProductionPlanBatchPrinting.vue?vue&type=template&id=703b13ca&scoped=true"
const script = {}

import "./DigitalProductionPlanBatchPrinting.vue?vue&type=style&index=0&id=703b13ca&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703b13ca"]])

export default __exports__